import http from './http'

export default function createCatalogService (route) {
  return {
    async getPaged (parameters) {
      const response = await http.get(`${route}/GetPaged`, { params: parameters })
      return response.data
    },
    async getById (id) {
      const response = await http.get(`${route}/GetById/${id}`)
      return response.data
    },
    async add (model) {
      const response = await http.post(`${route}/Add`, model)
      return response.data
    },
    async update (model) {
      await http.put(`${route}/Update`, model)
    },
    async remove (id) {
      await http.delete(`${route}/Delete/${id}`)
    }
  }
}
